import React from "react";
import { ReactComponent as DlivLogo } from "./logo.svg";
import "../index.css";
const SuperAdminNavBar = () => {
  return <DlivLogo className="superAdminNavBar" />;
};

export default SuperAdminNavBar;
